<template>
    <div class="wl-custom-form">
        <!-- 表单生成器 -->
        <fc-designer ref="designer" :menu="menu">
            <template slot="handle">
                <el-button type="primary" @click="fanhui">返回</el-button>
                <el-button type="primary" @click="getForm">保存设计</el-button>
            </template>
        </fc-designer>
        <!-- 创建表单 -->
        <!-- <form-create v-model="fapi" :rule="rule" :option="option" @submit="onSubmit"></form-create> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            fapi: null,
            option: {},
            rule: [],
            projectInfo:{},
            menu: [
                {
                    title: "表单组件",
                    name: "group",
                    list: [
                        {
                            icon: "icon-input",
                            name: "input",
                            label: "输入框",
                        },
                        {
                            icon: "icon-number",
                            name: "inputNumber",
                            label: "计数器",
                        },
                        {
                            icon: "icon-select",
                            name: "select",
                            label: "选择器",
                        },
                        {
                            icon: "icon-time",
                            name: "timePicker",
                            label: "时间选择器",
                        },
                        {
                            icon: "icon-date",
                            name: "datePicker",
                            label: "日期选择器",
                        },
                        {
                            icon: "icon-checkbox",
                            name: "checkbox",
                            label: "多选框",
                        },
                        {
                            icon: "icon-radio",
                            name: "radio",
                            label: "单选框",
                        }
                    ],
                },
                // {
                //     title: "布局组件",
                //     name: "group",
                //     list: [
                //         {
                //             icon: "icon-row",
                //             name: "row",
                //             label: "栅格布局",
                //         },
                //         {
                //             icon: "icon-space",
                //             name: "space",
                //             label: "间距",
                //         }
                //     ],
                // },
            ],
        };
    },
    props: {
        projectId:{
            type:String,
            default:""
        }
    },
    created() {
        this.getFormFieldsList();
    },
    methods: {
        getFormFieldsList(){
            var that = this;
            this.$http
                .post("/api/XOrg/FormFieldsManager/getFormFieldsList", {
                    projectId: this.projectId
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        if(rst.info){
                            that.projectInfo =  rst.projectInfo;
                            that.option = JSON.parse(rst.info.formRuleJson);
                            that.rule = JSON.parse(rst.info.formFieldsJson);
                            that.$nextTick(()=>{
                                // 设置设计器表单区域表单的生成规则
                                that.$refs.designer.setRule(that.rule);
                                // 设置设计器表单区域表单的规则
                                that.$refs.designer.setOption(that.option);
                            })
                            console.log(that.rule);
                        }
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getForm() {
            //FcDesigner 生成的`JSON`
            const FcDesignerRule = this.$refs.designer.getRule();
            //FcDesigner 生成的`options`
            const FcDesignerOptions = this.$refs.designer.getOption();

            this.option = FcDesignerOptions;
            this.rule = FcDesignerRule;

            console.log(FcDesignerRule);
            console.log(FcDesignerOptions);
            var that = this;
            this.$http
                .post("/api/XOrg/FormFieldsManager/addOrEditFormFields", {
                    projectId: this.projectId,
                    jsonStr: JSON.stringify(FcDesignerRule),
                    ruleJson: JSON.stringify(FcDesignerOptions)
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        // that.$router.push({
                        //     name: "projectManager"
                        // });
                        that.fanhui();
                        that.$message.success(rst.msg);
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        fanhui(){
            if(this.projectInfo.isModel==0){
                this.$router.push({
                    name: "projectManager"
                });
            }else{
                this.$router.push({
                    name: "projectModelManager"
                });
            }
            
        },
        onSubmit(formData) {
            console.log(formData);
            this.fapi.prepend(
                {
                    type: "input",
                    title: "商品简介",
                    field: "goods_info",
                    value: "",
                    props: {
                        type: "text",
                        placeholder: "请输入商品简介",
                    },
                    validate: [{ required: true, message: "请输入商品简介", trigger: "blur" }],
                },
                "goods-name"
            );
        },
    },
};
</script>

<style lang="scss">
.wl-custom-form {
    height: 100%;
    background: #fff;
}
</style>
